import { createNativeStackNavigator } from "@react-navigation/native-stack";

import DeliveryFulfillmentsHeader from "./DeliveryFulfillmentsHeader";
import {
  DeliveryFulfillmentsStackParamList,
  deliveryFulfillmentsRoutes,
} from "./types";
import {
  DeliveryFulfillmentsProvider,
  TDeliveryOptions,
} from "../contexts/DeliveryFulfillmentsContext";
import AutomaticFulfillmentsScreen from "../screens/AutomaticFulfillmentsScreen";
import DeliveryModeListScreen from "../screens/DeliveryModeListScreen";
import MapScreen from "../screens/MapScreen";
import PickupLocationScreen from "../screens/PickupLocationScreen";

const Stack = createNativeStackNavigator<DeliveryFulfillmentsStackParamList>();

export default function DeliveryFulfillmentsNavigator(props: TDeliveryOptions) {
  const { deliveryModeList, automaticFulfillments, pickupLocation, map } =
    deliveryFulfillmentsRoutes;

  return (
    <DeliveryFulfillmentsProvider {...props}>
      <Stack.Navigator
        initialRouteName={deliveryModeList}
        screenOptions={{
          header: () => <DeliveryFulfillmentsHeader />,
        }}
      >
        <Stack.Screen
          name={deliveryModeList}
          component={DeliveryModeListScreen}
        />
        <Stack.Screen
          name={automaticFulfillments}
          component={AutomaticFulfillmentsScreen}
        />
        <Stack.Screen name={pickupLocation} component={PickupLocationScreen} />
        <Stack.Screen name={map} component={MapScreen} />
      </Stack.Navigator>
    </DeliveryFulfillmentsProvider>
  );
}
